import "./index.css";

import {
  Avatar,
  Button,
  Card,
  Col,
  Divider,
  Grid,
  Menu,
  Row,
  Typography,
  message,
  theme,
} from "antd";
import {
  ConsoleSqlOutlined,
  ContainerFilled,
  ContainerOutlined,
  CreditCardOutlined,
  DatabaseOutlined,
  LogoutOutlined,
  MessageOutlined,
  SettingOutlined,
  UserOutlined,
} from "@ant-design/icons";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import Icon from "../util-components/Icon";
import { Link } from "react-router-dom";
import Sider from "antd/es/layout/Sider";
import { api } from "../../services/api";
import moment from "moment/moment";
import { useAuth } from "../../hooks/useAuth";
import { useHistory } from "react-router-dom";

const { useToken } = theme;
const { useBreakpoint } = Grid;


const SideBar = () => {

  const auth = useAuth();

  const menuItem = [
    {
      label: "Pagina Inicial",
      key: "/",
      icon: <UserOutlined />,
    },
    {
      label: "Meus cursos",
      key: "/mycourses",
      icon: <DatabaseOutlined />,
    },
    // {
    //   label: "Biblioteca de Cursos",
    //   key: "/course-library",
    //   icon: <DatabaseOutlined />,
    // },
    // {
    //   label: "Pergunte ao professor",
    //   icon: <MessageOutlined />,
    //   key: "/ask",
    // },
    {
      label: "Ficha financeira",
      key: "/financial-statement",
      icon: <CreditCardOutlined />,
    },
    {
      label: "Contratos",
      key: "/contracts",
      icon: <ContainerOutlined />,
    },
    {
      label: "Sair",
      key: "/leave",
      icon: <LogoutOutlined />,
    },
  ];



  const { token } = useToken();

  const screens = useBreakpoint();
  const navigate = useNavigate();
  const [current, setCurrent] = useState(null);
  const [data, setData] = useState([]);
  const [diffLogin, setDiffLogin] = useState()
  const onClickMenu = (item) => {
    const clicked = menuItem.find((_item) => _item.key === item.key);
    setCurrent(item.key);
    if (clicked.key !== "/leave") {
      navigate(clicked.key);
    } else {
      auth.logout()
    }

  };
  let componentMounted = true;



  const getInfos = async () => {
    await api.get(`/panel/student-dashboard`)
      .then((res) => {
        localStorage.setItem("dashboard", JSON.stringify(res.data.data));
        setData(res.data.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };



  useEffect(() => {
    if (componentMounted) {
      getInfos();
    }
    return () => {
      componentMounted = false;
    };
  }, []);

  const location = window.location.pathname

  useEffect(() => {
    const pathname = location.split('/')
    if (pathname[1] == '') {
      setCurrent('/')
    } else {
      setCurrent(`/${pathname[1]}`)
    }
  }, [location])


  useEffect(() => {
    const d1 = moment(data.last_login_at);
    const d2 = moment();
    const diff = moment(d2, "DD/MM/YYYY HH:mm:ss").diff(moment(d1, "DD/MM/YYYY HH:mm:ss"));

    const dias = moment.duration(diff).asDays();
    const horas = moment.duration(diff).asHours();
    const minutos = moment.duration(diff).asMinutes();

    const diffLogin = () => {
      if (Math.floor(dias) == 0 && Math.floor(horas) == 0) {
        return `Há ${Math.ceil(minutos)} minutos`
      } else if (Math.floor(dias) == 0 && Math.floor(horas) >= 1) {
        return `Há ${Math.ceil(horas)} horas`
      } else {
        return `Há ${Math.floor(dias)} dias`
      }
    }
    setDiffLogin(diffLogin())

  }, [data])

  return (
    <Sider
      style={{
        maxWidth: "300px",
        width: "100%",
        backgroundColor: "transparent",
      }}
    >
      <Card
        style={{
          width: "100%",
          padding: "0px !important",
          marginBottom: "40px",
          borderRadius: "3px",
        }}
      >
        <div
          style={{
            backgroundColor: token.colorPrimary,
            display: "flex",
            justifyContent: "center",
            height: "140px",
            position: "relative",
          }}
        >
          <Avatar
            style={{
              position: "absolute",
              bottom: "-50px",
              border: "2px solid #FFFFFF",
            }}
            size={100}
            src={"https://www.w3schools.com/w3images/avatar2.png"}
            onError={(e) => {
              e.target.onerror = null;
              e.target.src = "https://www.w3schools.com/w3images/avatar2.png";
            }}
          />
        </div>

        <Row
          style={{
            marginTop: "66px",
            display: "flex",
            justifyContent: "center",
            width: "100% !important",
          }}
        >
          <Typography className="title-profile">{data?.name}</Typography>
        </Row>
        <Row gutter={50} justify="center" align="top">
          <Col
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: "12px",
            }}
          >
            <div className="title-card">Cursos concluídos</div>
            <div className="subtitle-card">{data?.courses_info?.filter(el => el?.course_completion == 1 ? el : null)?.length}</div>
          </Col>
          <Divider type="vertical" style={{ height: "40px" }} />
          <Col
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: "12px",
            }}
          >
            <div className="title-card">Último acesso</div>
            <div className="subtitle-card">{diffLogin}</div>
          </Col>
        </Row>
        <Row justify="center">
          <Link to="/profile" className="view-profile">
            Visualizar perfil
          </Link>
        </Row>
      </Card>

      <Card
        style={{
          width: "100%",
          padding: "0px !important",
          marginBottom: "40px",
        }}
      >
        <Menu onClick={onClickMenu} selectedKeys={[current]} items={menuItem} />
      </Card>
    </Sider>
  );
};

export default SideBar;
